import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_497: DocMigration = {
  maxSchemaVersion: "0.0.497",
  description: "Migrate viewports with ABSOLUTE positioning to EXPLICIT positioning",
  apply(json: any): any {
    if (json.viewports) {
      for (const id in json.viewports) {
        const viewport = json.viewports[id];
        if (viewport.positioningMethod === "ABSOLUTE") {
          viewport.positioningMethod = "EXPLICIT";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_497;
